// Main store to store constants and other common stuff
import { isEmpty, find } from 'lodash-es'
import { api } from '@/api'
import to from '@/modules/await-to-js'

const state = {
  application: {},
  constants: {},
  hasFloatingButton: false,
  userHasFleets: null,
  userHasClusters: null
}

export const getters = {
  application: state => state.application,
  constants: state => state.constants,
  hasFloatingButton: state => state.hasFloatingButton,
  userHasFleets: state => state.userHasFleets,
  userHasClusters: state => state.userHasClusters,
  wgEnabled: state => {
    const wg = find(state.application.components, c => c.name === 'WG') || { status: 'NOT_CONFIGURED' }
    return wg.status !== 'NOT_CONFIGURED'
  }
}

export const mutations = {
  setApplication (state, application) {
    state.application = application
  },

  setConstants (state, constants) {
    state.constants = constants
  },

  setHasFloatingButton (state, hasFloatingButton) {
    state.hasFloatingButton = hasFloatingButton
  },

  setUserHasFleets (state, userHasFleets) {
    state.userHasFleets = userHasFleets
  },

  setUserHasClusters (state, userHasClusters) {
    state.userHasClusters = userHasClusters
  }
}

export const actions = {
  async getApplication (context, options) {
    let error, response
    [error, response] = await to(api.getApplication())

    if (error || !response) {
      // Commit empty applicationDto with KO and unknown statuses
      context.commit('setApplication', { 'name': 'GMS', 'status': 'KO' })
      return Promise.reject(error)
    }

    context.commit('setApplication', response.data)
    return Promise.resolve(response)
  },

  // Check the user has at least one fleet
  async checkUserHasFleets (context) {
    // Not before getting applicationDto...
    if (isEmpty(context.rootGetters.application)) return

    let error, response
    [error, response] = await to(api.checkUserHasFleets(context.rootGetters.application))

    if (error || !response) {
      // Failed to get list, consider it as at least one element
      context.commit('setUserHasFleets', true)
      return
    }
    context.commit('setUserHasFleets', response.data.totalCount > 0)
  },

  // Check the user has at least one cluster
  async checkUserHasClusters (context) {
    // Not before getting applicationDto...
    if (isEmpty(context.rootGetters.application)) return

    let error, response
    [error, response] = await to(api.checkUserHasClusters(context.rootGetters.application))

    if (error || !response) {
      // Failed to get list, consider it as at least one element
      context.commit('setUserHasClusters', true)
      return
    }

    context.commit('setUserHasClusters', response.data.totalCount > 0)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
